import { Grid, Box, Stack } from '@mui/material';

import { LoadingHOC, MediaCard } from '../../common_components';
import { ColorButton } from '../../common_components/styled';
import { useFetchUpcommingNfts } from '../../hooks/useClientDataService';

export const UpcommingNFT = () => {
  const { data: nftsList, hasNextPage, isLoading, fetchNextPage } = useFetchUpcommingNfts();

  if (isLoading) {
    return <LoadingHOC />;
  }

  return (
    <Box sx={{ m: 2, p: 2, pt: 0, mt: 0 }} elevation={3}>
      {nftsList.pages.map((page, index) => (
        <Grid container spacing={2} key={index}>
          {page.items.map((item, index) => (
            <Grid
              item
              xs={12}
              md={2}
              sm={4}
              key={index}
              sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <MediaCard key={index} {...item} index />
            </Grid>
          ))}
        </Grid>
      ))}
      <Stack justifyContent="center" display="flex" alignItems="center" sx={{ m: 2 }}>
        <ColorButton
          variant="contained"
          loading={false}
          onClick={fetchNextPage}
          disabled={!hasNextPage}>
          Show More
        </ColorButton>
      </Stack>
    </Box>
  );
};

export default UpcommingNFT;
